import React from "react";
import { useFormContext } from "react-hook-form";
import { FormSelect } from "../../../components/form/FormSelect";
import { useTranslation } from "react-i18next";
import { useFormEnergyClass } from "./hooks/energy.hooks";

interface EnergyClassFieldProps {}

export const energyClassOptions = [
  "A++",
  "A+",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
];

export const EnergyClassField: React.FC<EnergyClassFieldProps> = () => {
  const { t } = useTranslation();
  const { setValue } = useFormContext();

  const { isLoading } = useFormEnergyClass({
    onSuccess: (data) => {
      if (data) {
        setValue("energyClass", data.energy_class);
      }
    },
  });

  return (
    <FormSelect
      label={t("propertyForm.energyClass")}
      name="energyClass"
      values={energyClassOptions}
      disabled={isLoading}
      allowNull
    />
  );
};
